import { createTheme } from '@mui/material'
import { default as baseTheme } from 'shared/style/theme'

const theme = createTheme(baseTheme, {
    palette: {
        greyscale: {
            white: '#fff',
        },
        primary: {
            light: '#B2D3F1',
            main: '#006CB5',
            dark: '#001D33',
        },
        status: {
            grey: '#9E9E9E',
            red: '#EF5350',
            orange: '#FF7043',
            pink: '#EC407A',
            purple: '#7E57C2',
            blue: '#3F8FDA',
        },
        other: {
            secondary_light: 'rgba(0, 0, 0, 0.6)',
            link: '#007BC7', // candidate primary main is used as the link color for recruiters
            background: '#f1f7ff', // candidate primary main is used as the link color for recruiters,
            light_blue: '#1976d2',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                contained: {
                    backgroundColor: '#007BC7',
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#B2D3F1',
                    color: '#001D33',
                },
            },
        },
    },
})

export default theme
